﻿// © Microsoft Corporation. All rights reserved.

// /**
//  * The navigatio module
//  * @param {Escape} escape - The escape.
//  * @param {Document} document - The document.
//  * @returns {Navigation}
//  */
import escape from "./escape";

/** @type {Navigation} - The navigation object. */
var navigation = {
    getUrl: function(relativeUrl) {
        if (navigation.filter) {
            // @ts-ignore
            return navigation.filter(relativeUrl);
        }

        return relativeUrl;
    },
    navigate: function (url, replace) {
        if (navigation.filter) {
            // @ts-ignore
            url = navigation.filter(url);
        }
        if (replace) {
            location.replace(url);
        } else {
            location.href = url;
        }
    },
    getHostName: getHostName,
    parseUrl: parseUrl,
    isLocal: function (url) {
        var hostname = getHostName(url);
        return !hostname || (location.hostname == hostname);
    },
    getParams: getParams,
    getParamsFromUrl: function (url, supportMultiple?, decodeComponents?) {
        var queryString = url.split("?")[1];
        return getParams(queryString, supportMultiple, decodeComponents);
    },
    // merge query string parameters with a set of new parameters. This does not support duplicate keys
    mergeQueryStringParams: function (url, newParams) {
        if (newParams) {
            var urlParts = url.split("?");
            var params;
            if (urlParts[1]) {
                // get the existing parameters, then merge in the
                // new ones, overwriting any values that previously existed.
                params = getParams(urlParts[1], false, true);
                for (var param in newParams) {
                    params[param] = newParams[param];
                }
            } else {
                // no existing parameters, so just use the new ones directly
                params = newParams;
            }

            // now rebuild the url from the parameters
            url = urlParts[0];
            var separator = "?";
            for(var param in params) {
                if (params[param]) {
                    url += separator + escape.urlPart(param) + "=" + escape.urlPart(params[param]);
                } else {
                    url += separator + escape.urlPart(param);
                }
                separator = "&";
            }
        }

        return url;
    },
    filter: null
};

export default navigation;

function getParams(queryString, supportMultiple?, decodeComponents?) {
    var decodeURIComponentAndPlusSign = function (val) {
        val = val.replace(/\+/g, " ");
        val = decodeURIComponent(val);
        return val;
    };

    var params = {};
    if (queryString) {
        // remove hash part.
        queryString = queryString.split("#")[0];
        var queryArray = queryString.split("&");
        for (var ndx = 0; ndx < queryArray.length; ndx++) {
            var parts = queryArray[ndx].split("=");
            var key = parts[0];
            var value = parts[1];

            if (decodeComponents) {
                key = decodeURIComponentAndPlusSign(key);
                if (value) {
                    value = decodeURIComponentAndPlusSign(value);
                }
            }

            if (supportMultiple) {
                if (!params[key]) {
                    params[key] = [];
                }

                params[key].push(value);
            } else {
                params[key] = value;
            }
        }
    }

    return params;
}

/**
 * Parse the given URL.
 * For example, "http://example.com:3000/pathname/?search=test#hash" returns:
 * {
 *    protocol: "http:",
 *    host: "example.com:3000",
 *    hostName: "example.com",
 *    port: "3000",
 *    path: "/pathname/",
 *    hash: "#hash",
 *    query: "?search=test",
 *    origin: "http://example.com:3000"
 * }
 * @param {string} url
 * @returns {{ protocol: string, host: string, hostName: string, port: string, path: string, hash: string, query: string, origin: string }}
 */
function parseUrl(url) {
    var anchor = document.createElement("a");
    anchor.href = url;

    return {
        protocol: anchor.protocol,
        host: anchor.host,
        hostName: anchor.hostname,
        port: anchor.port,
        path: anchor.pathname,
        hash: anchor.hash,
        query: anchor.search,
        origin: anchor.origin
    };
}

function getHostName(url) {
    return parseUrl(url).hostName;
}
